export const SiteFooter = () => {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-border bg-[#FAFAFA]"
    >
      <div className="mx-auto grid max-w-[1280px] gap-10 px-6 py-14 md:grid-cols-12 lg:px-10">
        <div className="md:col-span-5">
          <p className="font-mono text-[10px] uppercase tracking-[0.32em] text-muted-foreground">
            Cierge Labs · A KATLAS experience
          </p>
          <h3 className="mt-4 font-serif text-3xl font-light tracking-tight text-foreground">
            A guided design environment for governed coordination.
          </h3>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-muted-foreground">
            Cierge Labs is the interactive studio for shaping governed AI,
            evidence and multi-stakeholder workflow use cases. Synthetic by
            default. Self-sovereign continuity. No requirement to disclose
            secrets to explore.
          </p>
        </div>
        <div className="md:col-span-7">
          <div className="grid grid-cols-2 gap-8 md:grid-cols-3">
            <div>
              <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-muted-foreground">
                Layer
              </p>
              <ul className="mt-3 space-y-2 text-sm text-foreground">
                <li>Cierge Labs (front)</li>
                <li>KATLAS (trust-critical)</li>
              </ul>
            </div>
            <div>
              <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-muted-foreground">
                Principles
              </p>
              <ul className="mt-3 space-y-2 text-sm text-foreground">
                <li>Purpose-bound exchange</li>
                <li>Attributable authority</li>
                <li>Signed receipts</li>
                <li>Selective disclosure</li>
              </ul>
            </div>
            <div>
              <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-muted-foreground">
                Posture
              </p>
              <ul className="mt-3 space-y-2 text-sm text-foreground">
                <li>Synthetic by default</li>
                <li>White-label deployment</li>
                <li>Path to private sandbox</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="border-t border-border">
        <div className="mx-auto flex max-w-[1280px] flex-col items-start justify-between gap-2 px-6 py-5 font-mono text-[10px] uppercase tracking-[0.18em] text-muted-foreground md:flex-row md:items-center lg:px-10">
          <span>© Cierge Labs · a KATLAS experience</span>
          <span>This environment retains no broad customer secrets.</span>
        </div>
      </div>
    </footer>
  );
};
